import { Chart } from "react-google-charts";
import React, { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import html2canvas from 'html2canvas';
import { Row, Col, Button } from 'react-bootstrap';
import { useProvider, Toast } from '../../context/MenuProvider';


import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");

const Metas = () => {
  const { 
    crud,
    buscarDadosPorId,
    hasPerms,
    site,
    salvarDados,
    handleCompartilhar,
  } = useProvider();
  const [dados, setDados] = useState([]);
  const [dadosDia, setDadosDia] = useState([]);
  const divDiaRef = useRef();
  const divMesRef = useRef();

  const hoje = new Date().toLocaleDateString('sv-SE');
  const tituloMes = `${dayjs(hoje).format('MMMM/YYYY')}`;
  const tituloDia = `${dayjs(hoje).format('dddd DD/MMMM')}`;

  const baseOptions = {
    hAxis: { minValue: 0, maxValue: 100, format: "#'%'"},
    chartArea: { width: "50%" },
    bars: "horizontal",
    legend: { position: "none" },
    annotations: {
      textStyle: { fontSize: 18, color: "#000" },
    },
  };
  
  
  const options = { 
    ...baseOptions, 
    title: tituloMes,
    vAxis: {
      title: site?.name,
      titleTextStyle: { fontSize: 8, italic: true, color: "#666" }
    },
    titleTextStyle: {
      fontSize: 14, // tamanho do título
      bold: true,
      color: "#000"
    },
  };
  
  const optionsDia = { 
    ...baseOptions, 
    title: tituloDia,
    vAxis: {
      title: site.name,
      titleTextStyle: { fontSize: 8, italic: true, color: "#666" }
    },
    titleTextStyle: {
      fontSize: 14,
      bold: true,
      color: "#000"
    },
  };

  // const options = { ...baseOptions, title: tituloMes };
  // const optionsDia = { ...baseOptions, title: tituloDia };


  useEffect(() => {
    const updateDados = async (data) => {
      try {
        var atualizado = {
          ...data,
          id:"metas_widget"
        }
        await salvarDados('local_registros', atualizado);
      } catch (err) {
        console.error(err);
      }
    };
    const carregarLocal = async()=>{
      try{
        const tiposArray = [];
        if (hasPerms(['loja.view_venda','loja.view_produtos'])) tiposArray.push('produtos', 'venda');
        if (hasPerms(['rede.view_apn'])) tiposArray.push('rede');
        if(!tiposArray.length) return;
        
        const response = await buscarDadosPorId('local_registros', "metas_widget");
        if(response){
          const base = response;
          setDados(base?.metas_widget_mes);
          setDadosDia(base?.metas_widget_dia);
        }
      }catch(err){
        
      }finally{
        carregarMetas();
      }
    }
    
    const carregarMetas = async () => {
      try {
        const [ano, mes] = hoje.split('-').map(Number);
        const tiposArray = [];
        if (hasPerms(['loja.view_venda','loja.view_produtos'])) tiposArray.push('produtos', 'venda');
        if (hasPerms(['rede.view_apn'])) tiposArray.push('rede');
        if(!tiposArray.length) return;
        const tipos = tiposArray.join(',');
        const response = await crud.get(
          `/gvendas/metas/?mes=${mes}&ano=${ano}&valor__gt=0&tipo__in=${tipos}&expand=categoria&filtros=progresso,nome,alcancado,valor,is_quantidade,diario,diferenca,producao_do_dia`
        );

        if (response && response.length) {
          const metas = response[0].results || [];
          //alert(JSON.stringify(metas))

          const dadosFormatados = [
            ["Meta", "Progresso", { role: "style" }, { role: "annotation" }],
            ...metas.map((meta) => {
              const alcancado = meta.is_quantidade ? Math.ceil(meta.alcancado || 0) : parseFloat(meta.alcancado || 0);
              const valor = meta.is_quantidade ? Math.ceil(meta.valor || 0) : parseFloat(meta.valor || 0);
              return [
                `${meta.categoria?.nome?`${meta.categoria?.nome} (${alcancado}/${valor})`: "não informado."}`,
                parseFloat(meta.progresso || 0),
                `${parseFloat(meta.diferenca || 0) === 0 ?"color: #4CAF50":"color: #EF5340"}`,
                `${parseFloat(meta.progresso || 0)}%`,
              ];
            }),
          ];

          const dadosFormatadosDia = [
            ["Meta", "Progresso", { role: "style" }, { role: "annotation" }],
            ...metas.map((meta) => {
              const progressoDia = meta.producao_do_dia?.progresso ?? 0;
              const alcancadoDia = meta.producao_do_dia?.alcancado ?? 0;
              const diario = meta.diario || 0;
              const valorDia = meta.is_quantidade ? Math.ceil(diario) : parseFloat(diario);
              const atingidoDia = meta.is_quantidade ? Math.ceil(alcancadoDia) : parseFloat(alcancadoDia);
              return [
                `${meta.categoria?.nome? `${meta.categoria?.nome} (${atingidoDia}/${valorDia})` : "não informado."}`,
                parseFloat(progressoDia),
                `${parseFloat(meta.diferenca || 0) === 0 ?"color: #4CAF50":"color: #EF5340"}`,
                `${parseFloat(progressoDia)}%`,
              ];
            }),
          ];

          setDados(dadosFormatados);
          setDadosDia(dadosFormatadosDia);
          updateDados({
            'metas_widget_mes':dadosFormatados,
            'metas_widget_dia':dadosFormatadosDia,
          });
        }
      } catch (err) {
        console.error("Erro ao carregar metas:", err);
      }
    };
    if (hasPerms(['loja.view_metamensal'])){
      carregarLocal();
    }
  }, []);
  
  return (
    <div data-aos="fade-up">
      {(hasPerms([`loja.add_metamensal`])) && (<>
        <Row>
          <Col className="text-center">
          <Button
            as={Link}
            to="/relatorios/metas/"
            variant="outline-secondary"
            className="btn-sm px-5"
          >
            Metas de {dayjs(hoje).format('MMMM/YYYY')}
          </Button>
          </Col>
        </Row>
      </>)}
      {hasPerms(['loja.view_metamensal']) && (
        <div className="d-flex flex-nowrap overflow-auto">
          <Col xs={12} md={6}>
            {dadosDia.length > 1 && (
              <>
                <div ref={divDiaRef}>
                  <Chart
                    chartType="BarChart"
                    width="100%"
                    height="400px"
                    data={dadosDia}
                    options={optionsDia}
                  />
                </div>
                <div className="mt-2 d-flex justify-content-center fs-1">
                  <i
                    onClick={() => handleCompartilhar(divDiaRef, {text:'Minha produção do dia', title:"Produção do dia"})}
                    className="m-2 bx bx-share-alt"
                  ></i>
                </div>
              </>
            )}
          </Col>
          <Col xs={12} md={6}>
            {dados.length > 1 && (
              <>
                <div ref={divMesRef}>
                  <Chart
                    chartType="BarChart"
                    width="100%"
                    height="400px"
                    data={dados}
                    options={options}
                  />
                </div>
                <div className="mt-2 d-flex justify-content-center fs-1">
                  <i
                    onClick={() => handleCompartilhar(divMesRef, {text:'Minha produção do mês', title:"Produção do mês"})}
                    className="m-2 bx bx-share-alt"
                  ></i>
                </div>
              </>
            )}
          </Col>
        </div>
      )}
    </div>
  );
};

export default Metas;